export default __webpack_public_path__ + "assets/icons/add.ca600595.svg";